import Alert, { type AlertColor } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import type { ReactElement, ReactNode } from 'react';

export type StatusPanelProps = {
    severity: AlertColor;
    title: string;
    body?: ReactNode;
    action?: ReactNode;
    footer?: ReactNode;
};

// TODO: VerifyEmail, MagicLink, ConfirmEmailChange and Impersonate still render this shape by hand, in hardcoded
// English. Repoint them here and translate them.
export function StatusPanel({ severity, title, body, action, footer }: StatusPanelProps): ReactElement {
    return (
        <Stack spacing={3} sx={{ alignItems: 'center', textAlign: 'center' }}>
            <Alert severity={severity} sx={{ width: '100%', textAlign: 'left' }}>
                <AlertTitle>{title}</AlertTitle>
                {body}
            </Alert>
            {action}
            {footer}
        </Stack>
    );
}
